module.exports = "img/header.jpg";